module.exports = __webpack_public_path__ + "static/Ecosystem-icon-18-14081c6c904831cef11c31d3a91ae712.png";